/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { B2BPartnerAddRequest as B2BServiceContractB2BPartnerB2BPartnerAddRequest } from '../models/B2bService/Contract/B2bPartner/b-2-b-partner-add-request';
import { B2BPartnerAddResponse as B2BServiceContractB2BPartnerB2BPartnerAddResponse } from '../models/B2bService/Contract/B2bPartner/b-2-b-partner-add-response';
import { B2BPartnerListResponse as B2BServiceContractB2BPartnerB2BPartnerListResponse } from '../models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { B2BPartnerSetRequest as B2BServiceContractB2BPartnerB2BPartnerSetRequest } from '../models/B2bService/Contract/B2bPartner/b-2-b-partner-set-request';
import { B2BVisOrgListResponse as B2BServiceContractB2BPartnerB2BVisOrgListResponse } from '../models/B2bService/Contract/B2bPartner/b-2-b-vis-org-list-response';

@Injectable({
  providedIn: 'root',
})
export class B2BPartnerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiB2BB2BPartnerAddPost
   */
  static readonly ApiB2BB2BPartnerAddPostPath = '/api/B2b/B2bPartnerAdd';

  /**
   * Add new b2b partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartneradd
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerAddPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerAddPost$Plain$Response(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerAddRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerAddPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>;
      })
    );
  }

  /**
   * Add new b2b partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartneradd
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerAddPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerAddPost$Plain(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerAddRequest
  },
  context?: HttpContext

): Observable<B2BServiceContractB2BPartnerB2BPartnerAddResponse> {

    return this.apiB2BB2BPartnerAddPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>) => r.body as B2BServiceContractB2BPartnerB2BPartnerAddResponse)
    );
  }

  /**
   * Add new b2b partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartneradd
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerAddPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerAddPost$Response(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerAddRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerAddPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>;
      })
    );
  }

  /**
   * Add new b2b partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartneradd
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerAddPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerAddPost(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerAddRequest
  },
  context?: HttpContext

): Observable<B2BServiceContractB2BPartnerB2BPartnerAddResponse> {

    return this.apiB2BB2BPartnerAddPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<B2BServiceContractB2BPartnerB2BPartnerAddResponse>) => r.body as B2BServiceContractB2BPartnerB2BPartnerAddResponse)
    );
  }

  /**
   * Path part for operation apiB2BB2BPartnerListGet
   */
  static readonly ApiB2BB2BPartnerListGetPath = '/api/B2b/B2bPartnerList';

  /**
   * List b2b-partners.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerlist
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerListGet$Plain$Response(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerListGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>;
      })
    );
  }

  /**
   * List b2b-partners.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerlist
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerListGet$Plain(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>> {

    return this.apiB2BB2BPartnerListGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>) => r.body as Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>)
    );
  }

  /**
   * List b2b-partners.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerlist
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerListGet$Response(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerListGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>;
      })
    );
  }

  /**
   * List b2b-partners.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerlist
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerListGet(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>> {

    return this.apiB2BB2BPartnerListGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>>) => r.body as Array<B2BServiceContractB2BPartnerB2BPartnerListResponse>)
    );
  }

  /**
   * Path part for operation apiB2BB2BPartnerSetPost
   */
  static readonly ApiB2BB2BPartnerSetPostPath = '/api/B2b/B2bPartnerSet';

  /**
   * Update data for b2b-partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerset
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerSetPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerSetPost$Response(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerSetRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerSetPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update data for b2b-partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerset
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerSetPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiB2BB2BPartnerSetPost(params?: {

    /**
     * interface language
     */
    lang?: string;
    body?: B2BServiceContractB2BPartnerB2BPartnerSetRequest
  },
  context?: HttpContext

): Observable<void> {

    return this.apiB2BB2BPartnerSetPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiB2BB2BPartnerRemoveDelete
   */
  static readonly ApiB2BB2BPartnerRemoveDeletePath = '/api/B2b/B2bPartnerRemove';

  /**
   * Delete b2b-partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerremove
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BPartnerRemoveDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerRemoveDelete$Response(params?: {

    /**
     * interface language
     */
    lang?: string;

    /**
     * id of the organization (b2b partner)
     */
    orgId?: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BPartnerRemoveDeletePath, 'delete');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.query('orgId', params.orgId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete b2b-partner.
   *
   * ### Claim
   *  boservice.b2b.b2bpartnerremove
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BPartnerRemoveDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BPartnerRemoveDelete(params?: {

    /**
     * interface language
     */
    lang?: string;

    /**
     * id of the organization (b2b partner)
     */
    orgId?: number;
  },
  context?: HttpContext

): Observable<void> {

    return this.apiB2BB2BPartnerRemoveDelete$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiB2BB2BVisOrgListGet
   */
  static readonly ApiB2BB2BVisOrgListGetPath = '/api/B2b/B2bVisOrgList';

  /**
   * List companies for b2b.
   *
   * ### Claim
   *  boservice.b2b.b2bvisorglist
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BVisOrgListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BVisOrgListGet$Plain$Response(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BVisOrgListGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>;
      })
    );
  }

  /**
   * List companies for b2b.
   *
   * ### Claim
   *  boservice.b2b.b2bvisorglist
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BVisOrgListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BVisOrgListGet$Plain(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>> {

    return this.apiB2BB2BVisOrgListGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>) => r.body as Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>)
    );
  }

  /**
   * List companies for b2b.
   *
   * ### Claim
   *  boservice.b2b.b2bvisorglist
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiB2BB2BVisOrgListGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BVisOrgListGet$Response(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>> {

    const rb = new RequestBuilder(this.rootUrl, B2BPartnerService.ApiB2BB2BVisOrgListGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>;
      })
    );
  }

  /**
   * List companies for b2b.
   *
   * ### Claim
   *  boservice.b2b.b2bvisorglist
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiB2BB2BVisOrgListGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiB2BB2BVisOrgListGet(params?: {

    /**
     * * language code
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>> {

    return this.apiB2BB2BVisOrgListGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>>) => r.body as Array<B2BServiceContractB2BPartnerB2BVisOrgListResponse>)
    );
  }

}
